<template>
  <div class="container">
    <div class="row" v-if="!add_item">
      <div class="form-group col-md-12">
        <div class="col-12 alert alert-info mb-0">
          <legend class="m-0">CLIENTES PRINCIPALES (HASTA LOS 2 ÚLTIMOS AÑOS) </legend>
        </div>
      </div>
      <div class="form-group col-md-12">
        <label class="control-label"> ¿Realiza alguna actividad lucrativa independiente al empleo, cargo o comisión? <b-button class="btn-popover" v-b-popover.hover.top="info.clientes"><i class="far fa-question-circle"></i></b-button></label>
        <p-radio class="d-inline-block" v-model="bandera" label="1">Si</p-radio>
        <p-radio class="d-inline-block" v-model="bandera" label="0">No</p-radio>
      </div>
    </div>
    <div v-if="bandera == '1'">
      <div v-if="add_item">
        <div class="row">
          <div class="col-12 alert alert-info"> Todos los datos de clientes principales de la pareja o dependientes económicos no serán públicos. </div>
        </div>
        <div class="row">
          <legend>Datos de quien realiza la actividad</legend>
          <div class="col-md-12 form-group">
            <label class="control-label">Señalar quien realiza la actividad <b-button class="btn-popover" v-b-popover.hover.top="info.propietario"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="propietario" v-validate="'required'" v-model="form_item.propietario" label="1" class="d-inline-block">Declarante</p-radio>
            <p-radio name="propietario" v-validate="'required'" v-model="form_item.propietario" label="2" class="d-inline-block">Pareja</p-radio>
            <p-radio name="propietario" v-validate="'required'" v-model="form_item.propietario" label="3" class="d-inline-block">Dependiente Económico</p-radio>
          </div>
          <small class="text-danger">{{ errors.first('propietario')}}</small>
          <div class="form-group col-6">
            <label class="control-label">Nombre de la empresa o servicio que proporciona <b-button class="btn-popover" v-b-popover.hover.top="info.nombre"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre" v-validate="'required'" v-model="form_item.nombre" placeholder="Nombre de la actividad comercial" />
            <small class="text-danger">{{ errors.first('nombre')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">RFC <b-button class="btn-popover" v-b-popover.hover.top="info.rfc"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc" placeholder="RFC" />
            <small class="text-danger">{{ errors.first('rfc')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Cliente principal <b-button class="btn-popover" v-b-popover.hover.top="info.tipo_persona"><i class="far fa-question-circle"></i></b-button></label>
            <p-radio name="tipo_persona" class="d-inline-block" v-validate="'required'" v-model="form_item.tipo_persona" label="1">Persona física</p-radio>
            <p-radio name="tipo_persona" class="d-inline-block" v-validate="'required'" v-model="form_item.tipo_persona" label="2">Persona moral</p-radio>
            <small class="text-danger">{{ errors.first('tipo_persona')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Señale el nombre o razón social del cliente principal <b-button class="btn-popover" v-b-popover.hover.top="info.nombre_cliente"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="nombre_cliente" v-validate="'required'" v-model="form_item.nombre_cliente" placeholder="Nombre del cliente principal del negocio" />
            <small class="text-danger">{{ errors.first('nombre_cliente')}}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label"> RFC del cliente principal <b-button class="btn-popover" v-b-popover.hover.top="info.rfc_cliente"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" name="rfc_cliente" v-validate="'required|uppercase|max:13|rfc'" v-model="form_item.rfc_cliente" placeholder="RFC del Cliente" />
            <small class="text-danger">{{ errors.first('rfc_cliente')}}</small>
            <small class="text-danger" v-show="validaciones.rfc"> El formato de la CURP no es válido, verifica la información </small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Sector productivo al que pertenece <b-button class="btn-popover" v-b-popover.hover.top="info.sector"><i class="far fa-question-circle"></i></b-button></label>
            <el-select  clearable class="select-default" name="sector" v-validate="'required'" filterable placeholder="Sector" v-model="form_item.sector_industria_id">
              <el-option v-for="option in sectores_industria" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('sector') }}</small>
          </div>
          <div class="form-group col-6">
            <label class="control-label">Monto aproximado del beneficio o ganancia mensual que obtiene del cliente principal <b-button class="btn-popover" v-b-popover.hover.top="info.monto"><i class="far fa-question-circle"></i></b-button></label>
<!--             <el-input-number name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0"></el-input-number>
 -->            <input type="number" name="monto" v-validate="'required|decimal:0'" v-model="form_item.monto" controls-position="right" :min="0">

            <!-- <input class="form-control" type="text" name="monto" v-validate="'required'" v-model="form_item.monto" placeholder="Monto aproximado"> -->
            <small class="text-danger">{{ errors.first('monto')}}</small>
          </div>
          <legend>Lugar donde se ubica <b-button class="btn-popover" v-b-popover.hover.top="info.lugar"><i class="far fa-question-circle"></i></b-button>
          </legend>
          <div class="form-group  col-6">
            <label class="control-label"> País </label>
            <el-select  clearable name="pais" v-validate="'required'" class="select-default" filterable placeholder="País" v-model="form_item.pais_id">
              <el-option v-for="option in paises" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('pais') }}</small>
          </div>
          <div class="form-group col-6" v-if="form_item.pais_id==150">
            <label class="control-label"> Entidad Federativa </label>
            <el-select  clearable class="select-default" name="entidad" v-validate="'required'" filterable placeholder="Entidad" v-model="form_item.entidad_federativa_id">
              <el-option v-for="option in entidades" class="select-default" :value="option.id" :label="option.nom_ent" :key="option.nom_ent">
              </el-option>
            </el-select>
            <small class="text-danger">{{ errors.first('entidad') }}</small>
          </div>
          <div class="form-group col-12">
            <label class="control-label">Aclaraciones / Observaciones <b-button class="btn-popover" v-b-popover.hover.top="info.observaciones"><i class="far fa-question-circle"></i></b-button></label>
            <input class="form-control" type="text" v-model="form_item.observaciones" placeholder="Aclaraciones / Observaciones">
          </div>
        </div>
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="addItem()">
            <span v-if="edit_item == null">
              <i class="fa fa-plus"></i> Agregar </span>
            <span v-else>
              <i class="fa fa-save"></i> Guardar </span>
          </button>
          <button class="btn btn-danger ml-3" @click.prevent="cancelEdit()">
            <span>
              <i class="fa fa-times"></i> Cancelar </span>
          </button>
        </div>
        <div class="row">
          <hr class="col-md-12 bg-info">
        </div>
      </div>
      <div v-if="!add_item">
        <div class="row justify-content-end m-3">
          <button class="btn btn-primary" @click.prevent="showItem()">
            <span>
              <i class="fa fa-plus"></i> Agregar </span>
          </button>
        </div>
        <div class="row mt-3 mb-4">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <v-text-field class="col-4 offset-8" v-model="search" append-icon="fa-search" placeholder="Buscar" single-line hide-details></v-text-field>
            <v-data-table :headers="headers" :items="table_list" :items-per-page="5" :search="search" class="" :fixed-header="true">
              <template v-slot:item.acciones="{ item }">
                <div class="d-flex justify-content-center">
                  <b-button @click.prevent="editItem(item)" class="btn-s edit mr-2" variant="success">
                    <i class="fas fa-pencil-alt"></i></b-button>
                  <br>
                  <b-button @click.prevent="removeItem(item)" class="btn-s delete" variant="danger">
                    <i class="fas fa-times"></i></b-button>
                </div>
              </template>
              <template v-slot:item.propietario="{ item }">
                <div>{{filterDeclarante(item.propietario)}}</div>
              </template>
              <template v-slot:item.tipo_persona="{ item }">
                <div>{{filterTipoPersona(item.tipo_persona)}}</div>
              </template>
              <template v-slot:item.sector_industria_id="{ item }">
                <div>{{filterSector(item.sector_industria_id)}}</div>
              </template>
              <template v-slot:item.monto="{ item }">
                <div>$ {{item.monto | currency}}</div>
              </template>
            </v-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from "element-ui";
  import Domicilio from "../Domicilio.vue";
  import {
    mapFields
  } from "vee-validate";
  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },
    data() {
      return {
        validaciones: {
          rfc: false
        },
        ip_id: 1,
        add_item: false,
        edit_item: null,
        bandera: "0",
        form_item: {},
        table_list: [],
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'Propietario',
          value: 'propietario',
          align: 'center',
        }, {
          text: 'Nombre de la empresa',
          value: 'nombre',
          align: 'center',
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center',
        }, {
          text: 'Cliente principal',
          value: 'tipo_persona',
          align: 'center',
        }, {
          text: 'Nombre o razón social del cliente',
          value: 'nombre_cliente',
          align: 'center',
        }, {
          text: 'RFC del cliente',
          value: 'rfc_cliente',
          align: 'center',
        }, {
          text: 'Sector productivo',
          value: 'sector_industria_id',
          align: 'center',
        }, {
          text: 'Monto mensual neto',
          value: 'monto',
          align: 'center',
        }, ],
        info: {
          clientes: 'En caso de tener alguna empresa, negocio o actividad lucrativa deberá señalar a sus clientes principales, siempre y cuando el beneficio o ganancia directa al Declarante supere mensualmente 250 Unidades de Medida y Actualización (UMA), refiriéndose al valor diario de ésta. Deberá reportar hasta los últimos dos años.',
          propietario: 'Señalar si es del Declarante, Pareja o dependiente económico.',
          nombre: 'Señalar nombre o razón social completos de la empresa o en su caso el servicio que proporciona.',
          rfc: 'Establecer los doce dígitos de la empresa. Proporcionar los dígitos completos del registro federal de contribuyentes.',
          tipo_persona: 'Seleccionar si es persona física o persona moral.',
          nombre_cliente: 'Indicar el nombre o razón social completos del cliente principal.',
          rfc_cliente: 'En caso de personas físicas proporcionar los trece dígitos. En caso de personas morales establecer los doce dígitos del cliente principal.',
          sector: 'Elegir el sector al que pertenece.',
          monto: 'Deberá señalar el monto neto sin centavos, de la ganancia que le genera el cliente principal.',
          lugar: 'Indicar si se encuentra en México, debiendo señalar entidad federativa; o en el extranjero, debiendo señalar el país donde se localiza.',
          observaciones: 'En este espacio el Declarante podrá realizar las aclaraciones u observaciones que considere pertinentes respecto de alguno o algunos de los incisos de este apartado.',
        },
      };
    },
    computed: {},
    watch: {},
    methods: {
      showItem() {
        this.add_item = true;
        this.$validator.resume();
        if (!this.form_item.pais_id) {
          //El id Mexico es 150
          this.form_item.pais_id = 150;
        }
      },
      cancelEdit() {
        //this.showItem();
        this.add_item = false;
        this.form_item = {};
        this.edit_item = null;
        this.$validator.pause();
      },
      addItem() {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.form_item) {
              this.loadButton(this.$refs.btnSave);
              this.form_item.ip_id = this.ip_id;
              this.$http.post("clientes_principales", this.form_item).then(response => {
                if (this.edit_item === undefined || this.edit_item === null) {
                  this.table_list.unshift({
                    ...response.data.response
                  });
                } else {
                  let index = this.table_list.map(u => {
                    return u.id;
                  }).indexOf(response.data.response.id);
                  this.table_list.splice(index, 1, response.data.response);
                }
                this.cancelEdit();
              }, error => {
                this.StepError(error);
              });
            }
          } else {
            this.StepW("Hay campos sin completar");
          }
        });
      },
      editItem(item) {
        this.showItem();
        this.edit_item = item;
        this.form_item = {
          ...this.edit_item
        };
        $(".main-panel").animate({
          scrollTop: 100
        }, 500, "swing");
      },
      removeItem(item) {
        if (item.id !== null) {
          this.Ask("Desea borrar este registro", () => {
            this.$http.delete("clientes_principales/" + item.id).then(response => {
              let index = this.table_list.map(u => {
                return u.id;
              }).indexOf(item.id);
              this.table_list.splice(index, 1);
              this.StepOk('Registro eliminado');
            }, error => {
              this.Err(error);
            });
          });
        }
      },
      /* validate() {
        if (this.add_item) {
          this.validaciones = {
            curp: false,
            rfc_parte: false
          };
          if (!this.curpValida(this.form_item.curp)) {
            this.validaciones.curp = true;
            return false;
          }
          if (!this.rfcValido(this.item_representacion.rfc_parte)) {
            this.validaciones.rfc_parte = true;
            return false;
          }
        }
        return this.$validator.validateAll();
      }, */
    },
    created() {
      this.ip_id = this.getKey('uid');
      this.$http.get("clientes_principales/" + this.ip_id).then(response => {
        this.table_list = response.data.response;
        if (this.table_list) {
          if (this.table_list.length > 0) {
            this.bandera = '1';
          }
        }
      }, error => {
        this.Err(error);
      });
    },
    mounted() {
      this.checkCatalogs();
      //El id Mexico es 150
      this.form_item.pais_id = 150;
    }
  };

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Intereses/ClientesPrincipales.vue